import { supabase } from '@/lib/supabase';
import { AppError, handleError } from '@/shared/utils/error-handling';

export const checkStorageLimit = async (orgId: number, fileSize: number) => {
  const { data, error } = await supabase.rpc('check_storage_limit', {
    p_org_id: orgId,
    p_file_size: fileSize,
  });

  if (error) {
    const appError: AppError = await handleError(error);
    throw appError;
  }

  return data;
};
